module.exports = __webpack_public_path__ + "img/check-mark.d2e8c358.svg";